export const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const capitalizeAllWords = (phrase) => {
  return phrase.split(' ').map(capitalize).join(' ');
};
